import { render, staticRenderFns } from "./ZTabsPane.vue?vue&type=template&id=58a5fb88&"
import script from "./ZTabsPane.vue?vue&type=script&lang=js&"
export * from "./ZTabsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZTabsPane.vue"
export default component.exports